// test2728
(2728 && 0);
